export default __webpack_public_path__ + "static/recognisable-light-7e7c99ebdc6ab54578facb44ad75234146f175ec7244cd5b4b46109b50a76b75.png";